import React, { useState } from "react";
import { authenticateAdmin } from "@/utils/admin/authentication";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Lock, User, AlertCircle } from "lucide-react";
import { PasswordInput } from "@/components/ui/password-input";

interface AdminLoginProps {
  onLoginSuccess: () => void;
}
const AdminLogin: React.FC<AdminLoginProps> = ({
  onLoginSuccess
}) => {
  const [email, setEmail] = useState("lou@schillaci.me");
  const [password, setPassword] = useState("!Christmas25!");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      console.log("Login form submitted, attempting authentication...");
      const success = await authenticateAdmin(email, password);
      console.log("Authentication result:", success);
      if (success) {
        console.log("Calling onLoginSuccess callback");
        onLoginSuccess();
      }
    } catch (err) {
      console.error("Unexpected login error:", err);
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return <div className="flex justify-center items-center min-h-[80vh] bg-[var(--clamalo-bg)]">
    <Card className="w-full max-w-md border border-[var(--clamalo-border)] shadow-xl bg-white">
      <CardHeader className="bg-[#E8F0F8] rounded-t-lg border-b border-[var(--clamalo-border)]">
        <CardTitle className="flex items-center gap-2 text-2xl text-[var(--clamalo-text-main)]">
          <Lock className="h-6 w-6 text-[var(--clamalo-text-main)]" />
          Admin Access
        </CardTitle>
        <CardDescription className="text-[var(--clamalo-text-secondary)]">Please enter your Clou Administrator credentials</CardDescription>
      </CardHeader>
      <CardContent className="p-6">
        {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md flex items-center gap-2 text-red-600">
            <AlertCircle className="h-4 w-4" />
            <p className="text-sm">{error}</p>
          </div>}
        <form onSubmit={handleLogin} className="space-y-6">
          <div className="space-y-2">
            <label htmlFor="email" className="block text-sm font-medium text-[var(--clamalo-text-main)]">
              Email
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="pl-10 bg-white border border-[var(--clamalo-border)] focus:border-[var(--clamalo-button-primary)] focus:bg-[#E8F0F8] hover:bg-[#E8F0F8] transition-colors" placeholder="admin@example.com" required />
            </div>
          </div>
          <div className="space-y-2">
            <label htmlFor="password" className="block text-sm font-medium text-[var(--clamalo-text-main)]">
              Password
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <PasswordInput
                id="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="pl-10 bg-white border border-[var(--clamalo-border)] focus:border-[var(--clamalo-button-primary)] focus:bg-[#E8F0F8] hover:bg-[#E8F0F8] transition-colors"
                placeholder="••••••••"
                required
              />
            </div>
          </div>
          <Button type="submit" className="w-full bg-[var(--clamalo-button-primary)] hover:bg-[#E8F0F8] text-[var(--clamalo-button-text)] font-semibold shadow-sm mt-4" disabled={loading}>
            {loading ? "Authenticating..." : "Login to Admin Panel"}
          </Button>
        </form>
      </CardContent>
    </Card>
  </div>;
};
export default AdminLogin;